import styles from './Articles.module.scss';
import ButtonBlue from '../../common/ButtonBlue/ButtonBlue';
import { Link } from 'react-router-dom';
// data
import { articles } from '../../../data/article';
import { FaCalendarAlt, FaRegClock } from 'react-icons/fa';

const Articles = () => {
  return (
    <div>
      <header className={styles.header}>
        <h1>Artykuły i wpisy </h1>
        <p>
          Czytaj nasze materiały edukacyjne na temat zdrowia psychicznego,
          terapii i najlepszych praktyk wspierania dobrostanu psychicznego.
        </p>
      </header>
      <div className={styles.articles}>
        <div>
          <div>
            <h3>Ostatnie wpisy </h3>

            {articles.map((article) => (
              <div key={article.id} className={styles.article}>
                <h3>{article.title}</h3>
                <p className={styles.description}>{article.sections[0].text}</p>
                <div className={styles.info}>
                  <span>
                    <FaCalendarAlt />
                  </span>
                  <p>{article.date} </p>
                  <span>
                    <FaRegClock />
                  </span>
                  <p> {article.readTime}</p>
                </div>

                <Link to={`/article/${article.id}`}>
                  <ButtonBlue>Czytaj artykuł</ButtonBlue>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;
